export default "__VITE_ASSET__DWyacMyZ__"